export type RootState = {}

export enum FetchStatus {
  NONE = 'NONE',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  FAILED = 'FAILED',
}
